import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { AUTH_EVENTS } from "~/lib/customEvents";

/**
 * Drops all TanStack Query cache entries when the auth layer signals a session
 * boundary (tenant switch or logout). Server data is tenant-scoped; keeping the
 * previous tenant's cache would leak stale rows into the next tenant's UI.
 */
export const QueryCacheLifecycle = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleSessionCleared = () => {
      queryClient.clear();
    };

    window.addEventListener(AUTH_EVENTS.sessionCleared, handleSessionCleared);
    return () => window.removeEventListener(AUTH_EVENTS.sessionCleared, handleSessionCleared);
  }, [queryClient]);

  return null;
};
